export const TABINDEX_NOT_TABBABLE = -1;
export const TABINDEX_TABBABLE = 0;